import React from 'react';
import { Link } from 'react-router-dom';
import './EsqueciScreen.css';

import Auth from '../../services/Auth';
import Carregando from '../../components/Carregando';

import validarEmail from '../../utils/validarEmail';
import * as ROUTES from '../../constants/routes';

export default class EsqueciScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: false,
      msgTexto: '',
      email: '',
    };
    this.recuperar = this.recuperar.bind(this);
  }

  async recuperar() {
    const { email } = this.state;
    let mensagem = '';

    await this.setState({ loading: true, msg: false });

    if (!email || email.length < 1) {
      mensagem = 'Informe o email para continuar.';
      this.setState({ loading: false, msg: true, msgTexto: mensagem });
      return null;
    }
    if (!validarEmail(email)) {
      mensagem = 'Informe um email válido para continuar.';
      this.setState({ loading: false, msg: true, msgTexto: mensagem });
      return null;
    }
    const recuperacao = await Auth.recuperarSenha(email);
    if (!recuperacao) {
      mensagem = 'Houve um erro na recuperação de sua senha. Por favor, verifique seu email e tente novamente.';
    }
    mensagem = 'As intruções para alteração de senha foram encaminhadas para o email informado.';
    this.setState({ loading: false, msg: true, msgTexto: mensagem });
    return null;
  }

  render() {
    const { loading, msg, msgTexto, email } = this.state;

    if (loading) {
      return <Carregando />;
    }

    return (
      <div className="Esqueci">
        <header className="Esqueci-header">
          <form onSubmit={this.recuperar}>
            <fieldset className="Esqueci-fieldset">
              <legend>Esqueci a senha</legend>
              <div className="Esqueci-Container">
                <input
                  className="Esqueci-Input"
                  type="text"
                  placeholder="E-mail"
                  value={email}
                  onChange={event => this.setState({ email: event.target.value })}
                />
                <input type="submit" value="Recuperar" />
                <Link to={ROUTES.ENTRAR}>Voltar</Link>
              </div>
            </fieldset>
            {msg ? <p>{msgTexto}</p> : null}
          </form>
        </header>
      </div>
    );
  }
}
